const selectors = {
  input: "div.search-bar--search-input",
  clearButton: "div.search-bar--search-input--clear-btn",
  submitButton: "div.search-bar--search-input--submit-btn",
};

export default selectors;
